import { useLayoutEffect } from "react";
import { TextFieldModel } from "./TextField.model";
import { TextFieldType } from "./TextField.const";

interface EventInterface extends Event {
  keyCode: number;
}

export const useTelInputValidation = (
  inputRef: React.RefObject<HTMLDivElement>,
  inputType: TextFieldModel["type"]
) => {
  useLayoutEffect(() => {
    if (inputType === TextFieldType.PHONE) {
      const preventTypingLetters = (event: EventInterface) => {
        if (event.keyCode !== 8 && (event.keyCode < 48 || event.keyCode > 57)) {
          event.preventDefault();
        }
      };

      const inputRefCurrent = inputRef.current;

      if (inputRefCurrent) {
        inputRefCurrent.addEventListener("keypress", preventTypingLetters);
      }

      return () => {
        if (inputRefCurrent) {
          inputRefCurrent.removeEventListener("keypress", preventTypingLetters);
        }
      };
    }
  }, [inputRef, inputType]);
};
